import { authFetch as sharedFetch } from "../utils/authFetch";
// Keep production order requests separate from the unchanged Service Auto API.
export function authFetch(url, options) {
  return sharedFetch(url.replace(/^\/comenzi(?=\/|\?|$)/, "/productie-simaus/legacy-comenzi"), options);
}
